import { formatHelper } from "helper/format";
import _get from "lodash.get";
import { readCkycVerificationFromDetails } from "helper/kycDocumentUpload";

const sentimentTrackerOnboardingParser = {};

sentimentTrackerOnboardingParser.onboardingData = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }

    return {
        currentStage: _get(res, "currentOnboardingStage", null),
        isOnboardingCompleted: _get(res, "isOnboardingCompleted", null),
        riskProfileId: _get(res, "riskProfileId", null),
        riskProfileName: _get(res, "riskProfileName", null),
        panNumber: _get(res, "panNumber", null) || _get(res, "pancardNumber", null),
        dateOfBirth: _get(res, "dateOfBirth", null) || _get(res, "dob", null),
        aadharNumber:
            _get(res, "aadharNumber", null) || _get(res, "aadhaarNumber", null),
        isManualKYC: _get(res, "isManualKYC", null),
        isPanUploaded: _get(res, "isPanUploaded", null),
        isAadhaarFrontUploaded: _get(res, "isAadhaarFrontUploaded", null),
        isAadhaarBackUploaded:
      _get(res, "isAadhaarBackUploaded", null) ||
      _get(res, "isAadharBackUploaded", null) ||
      _get(res, "aadharCardBackUploaded", null) ||
      _get(res, "aadhaarCardBackUploaded", null),
        documentStatus: _get(res, "documentStatus", null),
        ...readCkycVerificationFromDetails(res),
        duplicateStages: _get(res, "duplicateStages", null),
        portfolioId: _get(res, "tempCustomerPortfolioId", null),
    };
};

export { sentimentTrackerOnboardingParser };
